import styled from "@emotion/styled";
import { SetUpskillingTypeAction } from "../../redux/actions/UpskillingActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import SuggestionRow from "../../shared/components/SuggestionRow";
import UpskillingType, { textForUpskillingType } from "../../shared/enums/UpskillingType";

const StyledRow = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    maxWidth: '100%',
    gap: '15px',
}));

const UpskillingTypeSelection = () => {
    const savedJobs = useAppSelector(store => store.savedJobsState.jobsArray);
    const dispatch = useAppDispatch();

    const onTypeOfUpskillingSelected = (type: UpskillingType) => {
        dispatch(SetUpskillingTypeAction(type));
    }

    return (
        <StyledRow>
            {Object.values(UpskillingType).map((type, index) => {
                if (type === UpskillingType.savedJobs && savedJobs.length === 0) return undefined;
                return <SuggestionRow key={index} title={textForUpskillingType(type)} onClick={() => onTypeOfUpskillingSelected(type)} />
            })}
        </StyledRow>
    )
}

export default UpskillingTypeSelection